import React from "react";
import {WrappedItem, RTEWrapper} from "BaseComponents/Wrappers";
import {H3} from "BaseComponents/Text";
import {PrimaryButton, ButtonText} from "Buttons";
import {GetTextColor} from "Helpers/ColorHelper";
import styled from "styled-components";

export const CTAItem = ({Heading, Text, Link, BackgroundColor}) => {
    const {textColor, hoverColor} = GetTextColor(BackgroundColor);
    return (
        <WrappedItem
            className={'ctaItem'}
            justifyContent="space-between"
            margin="15px"
            padding="30px"
            alignItems="center"
            background={`#${BackgroundColor}`}
        >
            <TopWrapper>
                <H3 color={textColor}>{Heading}</H3>

                <RTEWrapper
                    textAlign="center"
                    margin="10px 0 0 0"
                    color={textColor}
                    dangerouslySetInnerHTML={{__html: Text}}
                />
            </TopWrapper>
            {Link && (
                <PrimaryButton
                    className={textColor === "#fff" ? 'fff' : ''}
                    hoverColor={textColor}
                    borderColor={textColor}
                    inverted
                    forcedColor={textColor}
                    textColorHover={hoverColor}
                    href={Link.Url}
                    target={Link?.Target ?? '_self'}
                    smallmargin="5px 0 0 0"
                    widthsmall="auto"
                    minwidthsmall="220px"
                >
                    <ButtonText color={textColor} paddingsmall="0 2rem" heading={Heading}>{Link.Name}</ButtonText>
                </PrimaryButton>
            )}
        </WrappedItem>
    );
};
const TopWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    align-items: center;
`;
